/**
 * Where the game links out of itself (D-091, D-134, D-136). Our own page links the itch.io page
 * and the game's Patreon page, and the end screen links Patreon too; inside a portal's frame
 * (itch.io's, CrazyGames') it links nowhere: a portal's rules, and the itch.io page carries its
 * own links. The front page's `#patreon-link` in `index.html` carries the same address.
 */
export const PATREON_URL = "https://www.patreon.com/Grudgefire";

export function linksOutside(): boolean {
  return window.top === window.self && (import.meta.env.VITE_PLATFORM ?? "local") === "local";
}
